import type { ReactNode } from "react";
import type { DialogProps } from "@mui/material/Dialog";
import MuiDialog from "@mui/material/Dialog";

type FullScreenDialogProps = {
  children: ReactNode;
  onClose?: () => void;
  paperId?: string;
  overflowY?: string;
  transitionDuration?: DialogProps["transitionDuration"];
};
export const FullScreenDialog = ({
  children,
  onClose,
  paperId = "",
  overflowY = "scroll",
  transitionDuration = { exit: 0 },
}: FullScreenDialogProps) => {
  return (
    <MuiDialog
      slotProps={{ paper: { id: paperId, sx: { overflowY, borderRadius: 0, p: 0 } } }}
      open
      fullScreen
      transitionDuration={transitionDuration}
      onClose={onClose}
    >
      {children}
    </MuiDialog>
  );
};
